<mat-sidenav-container
    class="example-container"
    [hasBackdrop]="isMobile"
    (backdropClick)="mobileSidebarOpen = false">
    <mat-sidenav
        class="sidebar"
        [mode]="isMobile ? 'over' : 'side'"
        [opened]="isMobile ? mobileSidebarOpen : true">
        <menu-sidebar (optionSelected)="closeMobileSidebar()"></menu-sidebar>
    </mat-sidenav>

    <mat-sidenav-content class="content">
        <div class="container-button">
            @if (isMobile) {
            <button
                type="button"
                class="mobile-menu-btn"
                (click)="toggleMobileSidebar()"
                aria-label="Abrir menú lateral">
                ☰
            </button>
            }
        </div>

        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>